var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 13.5C13.3125 13.5 12.7031 14.25 10.5 14.25C8.25 14.25 7.64062 13.5 6.28125 13.5C2.8125 13.5 0 16.3594 0 19.8281V21.75C0 23.0156 0.984375 24 2.25 24H18.75C19.9688 24 21 23.0156 21 21.75V19.8281C21 16.3594 18.1406 13.5 14.6719 13.5ZM19.5 21.75C19.5 22.1719 19.125 22.5 18.75 22.5H2.25C1.82812 22.5 1.5 22.1719 1.5 21.75V19.8281C1.5 17.1562 3.60938 15 6.28125 15C7.21875 15 8.10938 15.75 10.5 15.75C12.8438 15.75 13.7812 15 14.6719 15C17.3438 15 19.5 17.1562 19.5 19.8281V21.75ZM10.5 12C13.7812 12 16.5 9.32812 16.5 6C16.5 2.71875 13.7812 0 10.5 0C7.17188 0 4.5 2.71875 4.5 6C4.5 9.32812 7.17188 12 10.5 12ZM10.5 1.5C12.9375 1.5 15 3.5625 15 6C15 8.48438 12.9375 10.5 10.5 10.5C8.01562 10.5 6 8.48438 6 6C6 3.5625 8.01562 1.5 10.5 1.5Z",
    fill: "#2D5049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.be9b697c0249b3accb23a9ba5fc08bee.svg";
export { ForwardRef as ReactComponent };